module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "no-pad",
    attrs: {
      "mt-1": ""
    }
  }, [_c('div', {
    ref: "loader",
    class: ['loader', ("loader--" + (_vm.settingsObj.themeColor)), 'loader-bar-ping-pong', ("" + (_vm.getActiveStatus()))]
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('step-list', {
    attrs: {
      "settingsObj": _vm.settingsObj,
      "endpoint": "bio"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c42a89f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/About.vue
// module id = 457
// module chunks = 0